// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   TextField,
//   Button,
//   IconButton,
//   MenuItem,
//   Autocomplete,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   CircularProgress,
// } from "@mui/material";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import CloseIcon from "@mui/icons-material/Close";
// import dayjs from "dayjs";
// import { useSelector } from "react-redux";
// import { useUserDetailContext } from "../../UserDetailContext";
// import { useDispatch } from "react-redux";
// import { getInterviewers } from "../../../Redux/Reducers/JobReducer";
// import { getGoogleLocalPlaces } from "../../../Redux/helpers/JobsApi";
// import {
//   getProfessionalEvents,
//   postProfessionalEvents,
//   updateProfessionalEvents,
// } from "../../../Redux/Reducers/calendarReducer";
// import { getConnectedReducer } from "../../../Redux/Reducers/ContactReducer";
// import { getExperienceReducer } from "../../../Redux/Reducers/ProfileReducer";
// import TimePicker from "../../../Components/Utilities/TimePicker";
// import { useQuantityContext } from "../../../Components/QuantityContext";

// // ─── Shared z-index for all popover/popper dropdowns inside this drawer ───────
// const DROPDOWN_Z_INDEX = 9999;

// const ScheduleEvent = ({ open, onClose, selectedEvent, selectedDate }) => {
//   const dispatch = useDispatch();
//   const { openSnackbar } = useQuantityContext(); // Get snackbar function
//   const [loading, setLoading] = useState(false);
//   const companyCalender = useSelector((state) => state?.calender?.professionalEventsData) || [];
//   const formData = Array.isArray(selectedEvent)
//     ? selectedEvent[0]
//     : selectedEvent;
//   const [conflictDialogOpen, setConflictDialogOpen] = useState(false);
//   const [conflictInfo, setConflictInfo] = useState(null);
//   const [pendingFormattedData, setPendingFormattedData] = useState(null);
//   const ProfessionalExperience =
//     useSelector((state) => state?.ProfileArray?.experienceData?.data) || [];
//   const ProfessionalEducation =
//     useSelector((state) => state?.ProfileArray?.educationData?.data) || [];
//   const currentExperiences =
//     ProfessionalExperience?.filter(
//       (exp) => exp.is_currently_working === true && exp.is_verified
//     ) || [];

//   const currentEducation =
//     ProfessionalEducation?.filter(
//       (exp) => exp.is_pursuing === true && exp.is_verified
//     ) || [];

//     console.log("currentExperiencesMMMMM", currentExperiences ,  currentEducation  )

//   const getInitialTime = () => {
//     const now = dayjs();
//     if (dayjs(selectedDate).isSame(now, "day")) {
//       return now.minute() > 30
//         ? now.add(1, "hour").startOf("hour")
//         : now.startOf("hour");
//     }
//     return dayjs(selectedDate).hour(9).startOf("hour");
//   };

//   const [eventData, setEventData] = useState({
//     companyName: formData?.companyName || "",
//     title: formData?.title || "",
//     description: formData?.description || "",
//     attendees: formData?.attendees || [],
//     eventDate: formData?.startTime
//       ? dayjs(formData.startTime)
//       : dayjs(selectedDate),
//     startTime: formData?.startTime
//       ? dayjs(formData.startTime)
//       : getInitialTime(),
//     endTime: formData?.endTime
//       ? dayjs(formData.endTime)
//       : getInitialTime().add(1, "hour"),
//     companyDomain: formData?.companyDomain || "",
//     timeZone: formData?.timeZone || "Asia/Kolkata",
//     meetLink: formData?.meetLink || "",
//     location: formData?.location || "",
//     meetingType: formData?.meetingType || "Remote",
//   });

//   const [timeError, setTimeError] = useState(null);
//   const [locations, setLocations] = useState([]);
//   const [validationErrors, setValidationErrors] = useState({}); // Track validation errors
//   // const ProfessionalExperience = useSelector((state) => state?.ProfileArray?.experienceData?.data) || [];
//   const { userDetails } = useUserDetailContext();
//   console.log("userDetailsmmm", userDetails)
//   const interviewers = useSelector((state) => state?.jobs?.interviewers || []);
//   const interviwersList = interviewers?.interviewers || [];

//   console.log("ProfessionalExperience", ProfessionalExperience)

//   useEffect(() => {
//     if (selectedEvent) {
//       const formData = Array.isArray(selectedEvent)
//         ? selectedEvent[0]
//         : selectedEvent;
//       setEventData({
//         id: formData?.id || null,
//         companyName: formData?.companyName || "",
//         title: formData?.title || "",
//         description: formData?.description || "",
//         attendees:
//           formData?.attendees?.map((attendee) => ({
//             name: attendee.name,
//             email: attendee.email,
//             profile_pic: attendee.profile_pic,
//             user_ref_id: attendee.user_ref_id,
//           })) || [],
//         eventDate: formData?.startTime
//           ? dayjs(formData.startTime)
//           : dayjs(selectedDate),
//         startTime: formData?.startTime
//           ? dayjs(formData.startTime)
//           : getInitialTime(),
//         endTime: formData?.endTime
//           ? dayjs(formData.endTime)
//           : getInitialTime().add(1, "hour"),
//         companyDomain: formData?.companyDomain || "",
//         timeZone: formData?.timeZone || "Asia/Kolkata",
//         meetLink: formData?.meetLink || "",
//         location: formData?.location || "",
//         meetingType: formData?.meetingType || "Remote",
//       });
//     } else {
//       const defaultCompany = getVerifiedCurrentCompany(ProfessionalExperience)?.[0];
//       setEventData({
//         id: "",
//         companyName: defaultCompany?.company_name || "",
//         title: "",
//         description: "",
//         attendees: [],
//         eventDate: dayjs(selectedDate),
//         startTime: getInitialTime(),
//         endTime: getInitialTime().add(1, "hour"),
//         companyDomain: defaultCompany?.company_domain || "",
//         timeZone: "Asia/Kolkata",
//         meetLink: "",
//         location: "",
//         meetingType: "",
//       });
//     }
//   }, [selectedEvent]);

//   useEffect(() => {
//     if (open) {
//       let companyNameToFetch = "";
//       if (eventData.companyName) {
//         companyNameToFetch = eventData.companyName;
//       } else {
//         const defaultCompany = getVerifiedCurrentCompany(ProfessionalExperience)?.[0];
//         companyNameToFetch = defaultCompany?.company_name || "";
//       }
//       if (companyNameToFetch) fetchInterviewers(companyNameToFetch);
//     }
//   }, [open, dispatch]);

//   useEffect(() => {
//     if (open && eventData.companyName) {
//       fetchInterviewers(eventData.companyName);
//     }
//   }, [eventData.companyName, open, dispatch]);

//   const fetchInterviewers = async (companyName) => {
//     if (companyName) {
//       try {
//         const params = { company_name: companyName };
//         await dispatch(getInterviewers(params));
//       } catch (error) {
//         console.error("Failed to fetch interviewers:", error);
//       }
//     }
//   };

//   const handleCompanyChange = (e) => {
//     const selectedCompanyName = e.target.value;
//     const selectedCompany = ProfessionalExperience?.find(
//       (company) => company?.company_name === selectedCompanyName
//     );
//     const updatedEventData = {
//       ...eventData,
//       companyName: selectedCompany?.company_name || "",
//       companyDomain: selectedCompany?.company_domain || "",
//       companyLogo: selectedCompany?.company_logo || "",
//     };
//     setEventData(updatedEventData);
//     // Clear validation error for companyName if it exists
//     if (validationErrors.companyName) {
//       setValidationErrors(prev => ({ ...prev, companyName: null }));
//     }
//     if (selectedCompany?.company_name) {
//       fetchInterviewers(selectedCompany.company_name);
//     }
//   };

//   const saveEvent = async (formattedData) => {
//     if (loading) return;
//     setLoading(true);
//     try {
//       if (eventData.id) {
//         const newPayload = {
//           ...formattedData,
//           type:
//             new Date(selectedEvent?.startTime)?.getTime() ==
//               new Date(formattedData?.startTime)?.getTime() &&
//               new Date(selectedEvent?.endTime)?.getTime() ==
//               new Date(formattedData?.endTime)?.getTime()
//               ? "not_reschedule"
//               : "reschedule",
//         };
//         await dispatch(updateProfessionalEvents(newPayload));
//         openSnackbar("Event updated successfully!", "success");
//       } else {
//         await dispatch(postProfessionalEvents(formattedData));
//         openSnackbar("Event scheduled successfully!", "success");
//       }
//       await dispatch(getProfessionalEvents());
//       setEventData({
//         companyName: "",
//         title: "",
//         description: "",
//         attendees: [],
//         eventDate: dayjs(selectedDate),
//         startTime: getInitialTime(),
//         endTime: getInitialTime().add(1, "hour"),
//         companyDomain: "",
//         timeZone: "Asia/Kolkata",
//         meetLink: "",
//         location: "",
//         meetingType: "Remote",
//       });
//       onClose();
//     } catch (error) {
//       console.error("Failed to save event:", error);
//       openSnackbar(error?.response?.data?.message || "Failed to save event. Please try again.", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Validation function
//   const validateForm = () => {
//     const errors = {};

//     // Company Name validation
//     if (!eventData.companyName || eventData.companyName.trim() === "") {
//       errors.companyName = "Company name is required";
//     }

//     // Title validation
//     if (!eventData.title || eventData.title.trim() === "") {
//       errors.title = "Title is required";
//     }

//     // Description validation
//     if (!eventData.description || eventData.description.trim() === "") {
//       errors.description = "Description is required";
//     }

//     // Meeting Type validation
//     if (!eventData.meetingType || eventData.meetingType.trim() === "") {
//       errors.meetingType = "Meeting type is required";
//     }

//     // Meeting Link or Location validation based on meeting type
//     if (eventData.meetingType === "Remote") {
//       if (!eventData.meetLink || eventData.meetLink.trim() === "") {
//         errors.meetLink = "Meeting link is required for online meetings";
//       } else if (!eventData.meetLink.startsWith("http://") && !eventData.meetLink.startsWith("https://")) {
//         errors.meetLink = "Please enter a valid URL starting with http:// or https://";
//       }
//     } else if (eventData.meetingType === "Others") {
//       if (!eventData.location || eventData.location.trim() === "") {
//         errors.location = "Location is required for offline meetings";
//       }
//     }

//     // Date validation
//     if (!eventData.eventDate) {
//       errors.eventDate = "Event date is required";
//     }

//     // Time validation
//     if (!eventData.startTime) {
//       errors.startTime = "Start time is required";
//     }
//     if (!eventData.endTime) {
//       errors.endTime = "End time is required";
//     }

//     setValidationErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleSubmit = async () => {
//     if (loading) return;

//     // Reset time error
//     setTimeError(null);

//     // First validate all required fields
//     if (!validateForm()) {
//       openSnackbar("Please fill in all required fields", "error");
//       return;
//     }

//     const now = dayjs();

//     if (!eventData.startTime || !eventData.endTime || !eventData.eventDate) {
//       setTimeError("Please select date and both start and end times");
//       openSnackbar("Please select date and both start and end times", "error");
//       return;
//     }

//     const startDateTime = eventData.eventDate
//       .hour(eventData.startTime.hour())
//       .minute(eventData.startTime.minute())
//       .second(0);

//     const endDateTime = eventData.eventDate
//       .hour(eventData.endTime.hour())
//       .minute(eventData.endTime.minute())
//       .second(0);

//     let finalEndDateTime = endDateTime;
//     if (endDateTime.isBefore(startDateTime)) {
//       finalEndDateTime = endDateTime.add(1, "day");
//     }

//     if (startDateTime.isBefore(now)) {
//       const errorMsg = "Cannot schedule events in the past";
//       setTimeError(errorMsg);
//       openSnackbar(errorMsg, "error");
//       return;
//     }

//     if (finalEndDateTime.isBefore(startDateTime)) {
//       const errorMsg = "End time must be after start time";
//       setTimeError(errorMsg);
//       openSnackbar(errorMsg, "error");
//       return;
//     }

//     const formattedData = {
//       ...eventData,
//       startTime: startDateTime.toISOString(),
//       endTime: finalEndDateTime.toISOString(),
//       attendees: eventData.attendees.map((attendee) => ({
//         name: attendee.name,
//         user_ref_id: attendee.user_ref_id,
//         email: attendee.email,
//         profile_pic: attendee.profile_pic,
//       })),
//     };
//     delete formattedData.eventDate;

//     const excludeId = eventData.id || null;
//     const conflictingEvent = companyCalender.find((event) => {
//       if (excludeId && event.id === excludeId) return false;
//       const existingStart = dayjs(event.startTime);
//       const existingEnd = dayjs(event.endTime);
//       return startDateTime.isBefore(existingEnd) && finalEndDateTime.isAfter(existingStart);
//     });

//     if (conflictingEvent) {
//       setConflictInfo({
//         startTime: dayjs(conflictingEvent.startTime).format("HH:mm:ss"),
//         endTime: dayjs(conflictingEvent.endTime).format("HH:mm:ss"),
//       });
//       setPendingFormattedData(formattedData);
//       setConflictDialogOpen(true);
//       return;
//     }

//     await saveEvent(formattedData);
//   };

//   const handleDateChange = (newDate) => {
//     if (!newDate) return;
//     const now = dayjs();
//     if (newDate.isBefore(now, "day")) {
//       const errorMsg = "Cannot select a past date";
//       setTimeError(errorMsg);
//       openSnackbar(errorMsg, "error");
//       return;
//     }
//     setEventData({ ...eventData, eventDate: newDate });
//     setTimeError(null);
//     // Clear validation error for eventDate if it exists
//     if (validationErrors.eventDate) {
//       setValidationErrors(prev => ({ ...prev, eventDate: null }));
//     }
//   };

//   const handleStartTimeChange = (newTime) => {
//     if (!newTime) return;
//     setEventData({
//       ...eventData,
//       startTime: newTime,
//       endTime: newTime.isAfter(eventData.endTime)
//         ? newTime.add(1, "hour")
//         : eventData.endTime,
//     });
//     setTimeError(null);
//     // Clear validation errors for times
//     if (validationErrors.startTime) {
//       setValidationErrors(prev => ({ ...prev, startTime: null }));
//     }
//   };

//   const handleEndTimeChange = (newTime) => {
//     if (!newTime) return;
//     setEventData({ ...eventData, endTime: newTime });
//     setTimeError(null);
//     if (validationErrors.endTime) {
//       setValidationErrors(prev => ({ ...prev, endTime: null }));
//     }
//   };

//   const onChangeLocation = async (input) => {
//     try {
//       if (!input || typeof input !== "string") {
//         setLocations([]);
//         return;
//       }
//       if (input.length > 2) {
//         setLocations([]);
//         const response = await getGoogleLocalPlaces(input);
//         if (Array.isArray(response)) {
//           setLocations(response?.map((place) => ({ description: place, placeId: place })));
//         } else if (response?.predictions) {
//           const validLocations = response.predictions
//             .filter((place) => place?.description)
//             .map((place) => ({
//               description: place.description,
//               placeId: place.place_id || place.description,
//             }));
//           setLocations(validLocations);
//         } else {
//           setLocations([]);
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching locations:", error);
//       setLocations([]);
//     }
//   };

//   const getVerifiedCurrentCompany = (companies) => {
//     return (
//       companies?.filter(
//         (exp) =>
//           exp.is_verified &&
//           exp.is_currently_working
//       ) || []
//     );
//   };

//   useEffect(() => {
//     dispatch(getConnectedReducer());
//     dispatch(getExperienceReducer());
//   }, []);

//   // ─── Reusable MenuProps / popperProps applied to every dropdown ──────────────
//   const dropdownMenuProps = {
//     MenuProps: {
//       sx: { zIndex: DROPDOWN_Z_INDEX },
//       container: document.body,
//       anchorOrigin: { vertical: "bottom", horizontal: "left" },
//       transformOrigin: { vertical: "top", horizontal: "left" },
//     },
//   };

//   const dropdownPopperProps = {
//     componentsProps: {
//       popper: {
//         sx: { zIndex: DROPDOWN_Z_INDEX },
//         style: { zIndex: DROPDOWN_Z_INDEX },
//         container: document.body,
//         modifiers: [
//           { name: "preventOverflow", enabled: true, options: { boundary: "window" } },
//         ],
//       },
//     },
//   };

//   // ────────────────────────────────────────────────────────────────────────────

//   return (
//     <Box
//       sx={{
//         position: "fixed",
//         top: 0,
//         right: open ? 0 : "-30vw",
//         width: "25vw",
//         height: "100%",
//         backgroundColor: "#fff",
//         boxShadow: "-2px 0 10px rgba(0,0,0,0.15)",
//         transition: "right 0.3s ease",
//         zIndex: 2200,
//         overflowY: "auto",
//         scrollbarWidth: "none",
//       }}
//     >
//       <Box sx={{ p: 3, pb: 6 }}>
//         {/* ── Header ── */}
//         <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
//           <Typography variant="h6">
//             {eventData?.id ? "Edit Event" : "Schedule Event"}
//           </Typography>
//           <IconButton onClick={onClose} disabled={loading}>
//             <CloseIcon />
//           </IconButton>
//         </Box>

//         {/* ── Form ── */}
//         <Box sx={{ display: "grid", gap: 3 }}>

//           {/* Company Name */}
//           <TextField
//             select
//             label="Company Name"
//             fullWidth
//             required
//             disabled={loading}
//             error={!!validationErrors.companyName}
//             helperText={validationErrors.companyName}
//             value={
//               eventData?.companyName ||
//               getVerifiedCurrentCompany(ProfessionalExperience)?.[0]?.company_name ||
//               ""
//             }
//             onChange={handleCompanyChange}
//             SelectProps={dropdownMenuProps}
//           >
//             {getVerifiedCurrentCompany(ProfessionalExperience).map((company) => (
//               <MenuItem
//                 key={company?.id}
//                 value={company?.company_name}
//                 sx={{ display: "flex", alignItems: "center", gap: 2 }}
//               >
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                   {company?.company_logo && (
//                     <img
//                       src={company?.company_logo}
//                       alt={company?.company_name}
//                       style={{ width: 24, height: 24, objectFit: "contain" }}
//                     />
//                   )}
//                   <Typography>{company?.company_name}</Typography>
//                 </Box>
//               </MenuItem>
//             ))}
//           </TextField>

//           {/* Title */}
//           <TextField
//             label="Title"
//             fullWidth
//             required
//             disabled={loading}
//             error={!!validationErrors.title}
//             helperText={validationErrors.title}
//             value={eventData?.title}
//             onChange={(e) => {
//               setEventData({ ...eventData, title: e.target.value });
//               if (validationErrors.title) {
//                 setValidationErrors(prev => ({ ...prev, title: null }));
//               }
//             }}
//           />

//           {/* Description */}
//           <TextField
//             label="Description"
//             fullWidth
//             multiline
//             rows={3}
//             required
//             disabled={loading}
//             error={!!validationErrors.description}
//             helperText={validationErrors.description}
//             value={eventData?.description}
//             onChange={(e) => {
//               setEventData({ ...eventData, description: e.target.value });
//               if (validationErrors.description) {
//                 setValidationErrors(prev => ({ ...prev, description: null }));
//               }
//             }}
//           />

//           {/* Meeting Type */}
//           <TextField
//             select
//             label="Meeting Type"
//             fullWidth
//             required
//             disabled={loading}
//             error={!!validationErrors.meetingType}
//             helperText={validationErrors.meetingType}
//             value={eventData.meetingType}
//             onChange={(e) => {
//               setEventData({ ...eventData, meetingType: e.target.value });
//               if (validationErrors.meetingType) {
//                 setValidationErrors(prev => ({ ...prev, meetingType: null }));
//               }
//             }}
//             SelectProps={dropdownMenuProps}
//           >
//             <MenuItem value="Remote">Online</MenuItem>
//             <MenuItem value="Others">Offline</MenuItem>
//           </TextField>

//           {/* Meeting Link OR Location */}
//           {eventData.meetingType === "Remote" ? (
//             <TextField
//               label="Meeting Link"
//               fullWidth
//               required
//               disabled={loading}
//               error={!!validationErrors.meetLink}
//               helperText={validationErrors.meetLink}
//               value={eventData.meetLink}
//               onChange={(e) => {
//                 setEventData({ ...eventData, meetLink: e.target.value });
//                 if (validationErrors.meetLink) {
//                   setValidationErrors(prev => ({ ...prev, meetLink: null }));
//                 }
//               }}
//             />
//           ) : (
//             <Autocomplete
//               freeSolo
//               options={locations}
//               getOptionLabel={(option) => {
//                 if (!option) return "";
//                 return typeof option === "string" ? option : option.description || "";
//               }}
//               value={eventData?.location || null}
//               onChange={(event, newValue) => {
//                 setEventData({
//                   ...eventData,
//                   location: typeof newValue === "string" ? newValue : newValue?.description || "",
//                 });
//                 if (validationErrors.location) {
//                   setValidationErrors(prev => ({ ...prev, location: null }));
//                 }
//               }}
//               onInputChange={(event, newValue) => {
//                 if (event?.type === "change") onChangeLocation(newValue);
//               }}
//               filterOptions={(options, params) => {
//                 return options.filter((option) => {
//                   const value = typeof option === "string" ? option : option.description;
//                   return value.toLowerCase().includes(params.inputValue.toLowerCase());
//                 });
//               }}
//               disabled={loading}
//               {...dropdownPopperProps}
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   label="Location"
//                   required
//                   variant="outlined"
//                   fullWidth
//                   disabled={loading}
//                   error={!!validationErrors.location}
//                   helperText={validationErrors.location}
//                   InputProps={{ ...params.InputProps, style: { fontSize: "0.875rem" } }}
//                 />
//               )}
//               renderOption={(props, option) => (
//                 <li {...props}>
//                   <Typography variant="body2">
//                     {typeof option === "string" ? option : option.description}
//                   </Typography>
//                 </li>
//               )}
//               noOptionsText="No locations found"
//               loading={locations.length === 0}
//               loadingText="Searching locations..."
//             />
//           )}

//           {/* Date & Time */}
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <Box>
//               <DatePicker
//                 label="Event Date"
//                 value={eventData.eventDate}
//                 onChange={handleDateChange}
//                 minDate={dayjs()}
//                 disabled={loading}
//                 slotProps={{
//                   textField: {
//                     fullWidth: true,
//                     sx: { mb: 2 },
//                     error: !!validationErrors.eventDate,
//                     helperText: validationErrors.eventDate,
//                     required: true
//                   },
//                   popper: {
//                     sx: { zIndex: DROPDOWN_Z_INDEX },
//                     container: document.body,
//                     modifiers: [
//                       { name: "preventOverflow", enabled: true, options: { boundary: "window" } },
//                     ],
//                   },
//                 }}
//               />

//               <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
//                 <TimePicker
//                   label="Start Time"
//                   value={eventData.startTime}
//                   onChange={handleStartTimeChange}
//                   error={!!validationErrors.startTime || !!timeError}
//                   helperText={validationErrors.startTime || timeError}
//                   disabled={loading}
//                   componentsProps={{
//                     popper: { sx: { zIndex: DROPDOWN_Z_INDEX }, container: document.body },
//                   }}
//                 />
//                 <TimePicker
//                   label="End Time"
//                   value={eventData.endTime}
//                   onChange={handleEndTimeChange}
//                   error={!!validationErrors.endTime || !!timeError}
//                   helperText={validationErrors.endTime || timeError}
//                   disabled={loading}
//                   componentsProps={{
//                     popper: { sx: { zIndex: DROPDOWN_Z_INDEX }, container: document.body },
//                   }}
//                 />
//               </Box>
//             </Box>
//           </LocalizationProvider>

//           {/* Attendees */}
//           <Autocomplete
//             multiple
//             options={interviwersList}
//             getOptionLabel={(option) =>
//               `${option?.first_name || ""} ${option?.last_name || ""}${option?.email ? ` (${option?.email})` : ""
//               }`
//             }
//             filterOptions={(options, { inputValue }) => {
//               const input = inputValue.toLowerCase();
//               return options.filter(
//                 (option) =>
//                   (option.first_name?.toLowerCase() || "").includes(input) ||
//                   (option.last_name?.toLowerCase() || "").includes(input) ||
//                   (option.email?.toLowerCase() || "").includes(input)
//               );
//             }}
//             value={interviwersList?.filter((interviewer) =>
//               eventData?.attendees?.some((attendee) => attendee?.email === interviewer?.email)
//             )}
//             onChange={(_, newValue) => {
//               const attendees = newValue?.map((interviewer) => ({
//                 name: [interviewer.first_name, interviewer.last_name].filter(Boolean).join(" "),
//                 email: interviewer?.email,
//                 user_ref_id: interviewer?.reference_id,
//                 profile_pic:
//                   interviewer?.profile_url ||
//                   "https://static-00.iconduck.com/assets.00/avatar-default-icon-2048x2048-h6w375ur.png",
//               }));
//               setEventData({ ...eventData, attendees });
//             }}
//             disabled={loading}
//             {...dropdownPopperProps}
//             renderTags={() => null}
//             renderOption={(props, option) => (
//               <li {...props}>
//                 <img
//                   src={
//                     option.profile_url ||
//                     "https://static-00.iconduck.com/assets.00/avatar-default-icon-2048x2048-h6w375ur.png"
//                   }
//                   alt={`${option.first_name || ""} ${option.last_name || ""}`}
//                   style={{ width: 32, height: 32, borderRadius: "50%", marginRight: 8, objectFit: "cover" }}
//                 />
//                 <span>
//                   {option.first_name || ""} {option.last_name || ""}
//                 </span>
//               </li>
//             )}
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 label="Attendees"
//                 placeholder="Search by name or email"
//                 disabled={loading}
//               />
//             )}
//           />

//           {/* Selected attendees chips */}
//           <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, maxHeight: 150, overflowY: "auto", p: 1, borderRadius: 1 }}>
//             {eventData?.attendees?.map((attendee, index) => (
//               <Box
//                 key={attendee.email}
//                 sx={{ display: "flex", alignItems: "center", gap: 1, p: 1, bgcolor: "background.paper", borderRadius: 4, boxShadow: 1 }}
//               >
//                 <img
//                   src={
//                     attendee.profile_pic ||
//                     "https://www.shutterstock.com/image-vector/default-avatar-profile-icon-transparent-600nw-2463868853.jpg"
//                   }
//                   alt={attendee.name}
//                   style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover" }}
//                 />
//                 <Typography variant="body2">{attendee.name}</Typography>
//                 <IconButton
//                   size="small"
//                   onClick={() => {
//                     const newAttendees = [...eventData.attendees];
//                     newAttendees.splice(index, 1);
//                     setEventData({ ...eventData, attendees: newAttendees });
//                   }}
//                   sx={{ ml: 0.5 }}
//                   disabled={loading}
//                 >
//                   <CloseIcon fontSize="small" />
//                 </IconButton>
//               </Box>
//             ))}
//           </Box>

//           {/* Submit */}
//           <Button
//             variant="contained"
//             fullWidth
//             onClick={handleSubmit}
//             disabled={loading}
//             sx={{ mt: 2 }}
//           >
//             {loading ? (
//               <CircularProgress size={24} color="inherit" />
//             ) : (
//               eventData?.id ? "Update Event" : "Schedule Event"
//             )}
//           </Button>
//         </Box>
//       </Box>

//       {/* ── Time Slot Conflict Dialog ── */}
//       <Dialog
//         open={conflictDialogOpen}
//         onClose={() => setConflictDialogOpen(false)}
//         sx={{ zIndex: DROPDOWN_Z_INDEX }}
//         PaperProps={{ sx: { borderRadius: 3, p: 1, maxWidth: 380, backgroundColor: "#ffffff" } }}
//       >
//         <DialogTitle sx={{ fontWeight: 700, fontSize: "1.1rem", pb: 0 }}>
//           Time Slot Unavailable
//           <IconButton
//             onClick={() => setConflictDialogOpen(false)}
//             sx={{ position: "absolute", right: 8, top: 8, color: "grey.500" }}
//             disabled={loading}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent sx={{ pt: 1 }}>
//           <DialogContentText sx={{ color: "text.primary", fontSize: "0.95rem" }}>
//             The time slot from <strong>{conflictInfo?.startTime}</strong> to{" "}
//             <strong>{conflictInfo?.endTime}</strong> is already booked. Are you sure you
//             want to select this time?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
//           <Button
//             onClick={() => setConflictDialogOpen(false)}
//             variant="outlined"
//             disabled={loading}
//             sx={{ textTransform: "none", fontWeight: 600, borderColor: "#ccc", color: "text.primary", borderRadius: 2, flex: 1 }}
//           >
//             Change Time
//           </Button>
//           <Button
//             onClick={async () => {
//               setConflictDialogOpen(false);
//               await saveEvent(pendingFormattedData);
//               setPendingFormattedData(null);
//             }}
//             variant="contained"
//             disabled={loading}
//             sx={{ textTransform: "none", fontWeight: 600, backgroundColor: "#0044C6", borderRadius: 2, flex: 1, "&:hover": { backgroundColor: "#0035a0" } }}
//           >
//             Select Anyway
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default ScheduleEvent;

import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  MenuItem,
  Autocomplete,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { useUserDetailContext } from "../../UserDetailContext";
import { useDispatch } from "react-redux";
import { getInterviewers } from "../../../Redux/Reducers/JobReducer";
import { getGoogleLocalPlaces } from "../../../Redux/helpers/JobsApi";
import {
  getProfessionalEvents,
  postProfessionalEvents,
  updateProfessionalEvents,
} from "../../../Redux/Reducers/calendarReducer";
import { getConnectedReducer } from "../../../Redux/Reducers/ContactReducer";
import { getExperienceReducer } from "../../../Redux/Reducers/ProfileReducer";
import TimePicker from "../../../Components/Utilities/TimePicker";
import { useQuantityContext } from "../../../Components/QuantityContext";

// ─── Shared z-index for all popover/popper dropdowns inside this drawer ───────
const DROPDOWN_Z_INDEX = 9999;

const ScheduleEvent = ({ open, onClose, selectedEvent, selectedDate }) => {
  const dispatch = useDispatch();
  const { openSnackbar } = useQuantityContext();
  const [loading, setLoading] = useState(false);
  const companyCalender = useSelector((state) => state?.calender?.professionalEventsData) || [];
  const formData = Array.isArray(selectedEvent)
    ? selectedEvent[0]
    : selectedEvent;
  const [conflictDialogOpen, setConflictDialogOpen] = useState(false);
  const [conflictInfo, setConflictInfo] = useState(null);
  const [pendingFormattedData, setPendingFormattedData] = useState(null);
  const ProfessionalExperience =
    useSelector((state) => state?.ProfileArray?.experienceData?.data) || [];
  const ProfessionalEducation =
    useSelector((state) => state?.ProfileArray?.educationData?.data) || [];
  const currentExperiences =
    ProfessionalExperience?.filter(
      (exp) => exp.is_currently_working === true && exp.is_verified
    ) || [];

  const currentEducation =
    ProfessionalEducation?.filter(
      (exp) => exp.is_pursuing === true && exp.is_verified
    ) || [];

  // Check if user has verified current company
  const hasVerifiedCompany = currentExperiences.length > 0;
  const hasOnlyVerifiedEducation = !hasVerifiedCompany && currentEducation.length > 0;

  const getInitialTime = () => {
    const now = dayjs();
    if (dayjs(selectedDate).isSame(now, "day")) {
      return now.minute() > 30
        ? now.add(1, "hour").startOf("hour")
        : now.startOf("hour");
    }
    return dayjs(selectedDate).hour(9).startOf("hour");
  };

  const [eventData, setEventData] = useState({
    companyName: formData?.companyName || "",
    title: formData?.title || "",
    description: formData?.description || "",
    attendees: formData?.attendees || [],
    eventDate: formData?.startTime
      ? dayjs(formData.startTime)
      : dayjs(selectedDate),
    startTime: formData?.startTime
      ? dayjs(formData.startTime)
      : getInitialTime(),
    endTime: formData?.endTime
      ? dayjs(formData.endTime)
      : getInitialTime().add(1, "hour"),
    companyDomain: formData?.companyDomain || "",
    timeZone: formData?.timeZone || "Asia/Kolkata",
    meetLink: formData?.meetLink || "",
    location: formData?.location || "",
    meetingType: formData?.meetingType || "Remote",
  });

  const [timeError, setTimeError] = useState(null);
  const [locations, setLocations] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const { userDetails } = useUserDetailContext();
  const interviewers = useSelector((state) => state?.jobs?.interviewers || []);
  const interviwersList = interviewers?.interviewers || [];

  useEffect(() => {
    if (selectedEvent) {
      const formData = Array.isArray(selectedEvent)
        ? selectedEvent[0]
        : selectedEvent;
      setEventData({
        id: formData?.id || null,
        companyName: formData?.companyName || "",
        title: formData?.title || "",
        description: formData?.description || "",
        attendees:
          formData?.attendees?.map((attendee) => ({
            name: attendee.name,
            email: attendee.email,
            profile_pic: attendee.profile_pic,
            user_ref_id: attendee.user_ref_id,
          })) || [],
        eventDate: formData?.startTime
          ? dayjs(formData.startTime)
          : dayjs(selectedDate),
        startTime: formData?.startTime
          ? dayjs(formData.startTime)
          : getInitialTime(),
        endTime: formData?.endTime
          ? dayjs(formData.endTime)
          : getInitialTime().add(1, "hour"),
        companyDomain: formData?.companyDomain || "",
        timeZone: formData?.timeZone || "Asia/Kolkata",
        meetLink: formData?.meetLink || "",
        location: formData?.location || "",
        meetingType: formData?.meetingType || "Remote",
      });
    } else {
      // If user has only verified education (no verified company), use user's name
      let defaultCompanyName = "";
      let defaultCompanyDomain = "";
      
      if (hasOnlyVerifiedEducation) {
        // Use user's name from userDetails
        defaultCompanyName = userDetails?.name || userDetails?.firstName + " " + userDetails?.lastName || userDetails?.companyname || "";
        defaultCompanyDomain = "";
      } else {
        // Use verified company if available
        const defaultCompany = getVerifiedCurrentCompany(ProfessionalExperience)?.[0];
        defaultCompanyName = defaultCompany?.company_name || "";
        defaultCompanyDomain = defaultCompany?.company_domain || "";
      }
      
      setEventData({
        id: "",
        companyName: defaultCompanyName,
        title: "",
        description: "",
        attendees: [],
        eventDate: dayjs(selectedDate),
        startTime: getInitialTime(),
        endTime: getInitialTime().add(1, "hour"),
        companyDomain: defaultCompanyDomain,
        timeZone: "Asia/Kolkata",
        meetLink: "",
        location: "",
        meetingType: "",
      });
    }
  }, [selectedEvent, hasOnlyVerifiedEducation, userDetails]);

  useEffect(() => {
    if (open) {
      let companyNameToFetch = "";
      if (eventData.companyName && !hasOnlyVerifiedEducation) {
        companyNameToFetch = eventData.companyName;
      } else if (!hasOnlyVerifiedEducation) {
        const defaultCompany = getVerifiedCurrentCompany(ProfessionalExperience)?.[0];
        companyNameToFetch = defaultCompany?.company_name || "";
      }
      if (companyNameToFetch) fetchInterviewers(companyNameToFetch);
    }
  }, [open, dispatch, hasOnlyVerifiedEducation]);

  useEffect(() => {
    if (open && eventData.companyName && !hasOnlyVerifiedEducation) {
      fetchInterviewers(eventData.companyName);
    }
  }, [eventData.companyName, open, dispatch, hasOnlyVerifiedEducation]);

  const fetchInterviewers = async (companyName) => {
    if (companyName) {
      try {
        const params = { company_name: companyName };
        await dispatch(getInterviewers(params));
      } catch (error) {
        console.error("Failed to fetch interviewers:", error);
      }
    }
  };

  const handleCompanyChange = (e) => {
    const selectedCompanyName = e.target.value;
    const selectedCompany = ProfessionalExperience?.find(
      (company) => company?.company_name === selectedCompanyName
    );
    const updatedEventData = {
      ...eventData,
      companyName: selectedCompany?.company_name || "",
      companyDomain: selectedCompany?.company_domain || "",
      companyLogo: selectedCompany?.company_logo || "",
    };
    setEventData(updatedEventData);
    if (validationErrors.companyName) {
      setValidationErrors(prev => ({ ...prev, companyName: null }));
    }
    if (selectedCompany?.company_name) {
      fetchInterviewers(selectedCompany.company_name);
    }
  };

  const saveEvent = async (formattedData) => {
    if (loading) return;
    setLoading(true);
    try {
      // If user has only verified education, add user details to payload
      const payloadToSend = {
        ...formattedData,
        ...(hasOnlyVerifiedEducation && {
          username: userDetails?.name || userDetails?.firstName + " " + userDetails?.lastName,
          userEmail: userDetails?.email,
          userReferenceId: userDetails?.reference_id,
          isScheduledForSelf: true,
        }),
      };

      if (eventData.id) {
        const newPayload = {
          ...payloadToSend,
          type:
            new Date(selectedEvent?.startTime)?.getTime() ==
              new Date(payloadToSend?.startTime)?.getTime() &&
              new Date(selectedEvent?.endTime)?.getTime() ==
              new Date(payloadToSend?.endTime)?.getTime()
              ? "not_reschedule"
              : "reschedule",
        };
        await dispatch(updateProfessionalEvents(newPayload));
        openSnackbar("Event updated successfully!", "success");
      } else {
        await dispatch(postProfessionalEvents(payloadToSend));
        openSnackbar("Event scheduled successfully!", "success");
      }
      await dispatch(getProfessionalEvents());
      setEventData({
        companyName: "",
        title: "",
        description: "",
        attendees: [],
        eventDate: dayjs(selectedDate),
        startTime: getInitialTime(),
        endTime: getInitialTime().add(1, "hour"),
        companyDomain: "",
        timeZone: "Asia/Kolkata",
        meetLink: "",
        location: "",
        meetingType: "Remote",
      });
      onClose();
    } catch (error) {
      console.error("Failed to save event:", error);
      openSnackbar(error?.response?.data?.message || "Failed to save event. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  const validateForm = () => {
    const errors = {};

    if (!eventData.companyName || eventData.companyName.trim() === "") {
      errors.companyName = "Company name is required";
    }

    if (!eventData.title || eventData.title.trim() === "") {
      errors.title = "Title is required";
    }

    if (!eventData.description || eventData.description.trim() === "") {
      errors.description = "Description is required";
    }

    if (!eventData.meetingType || eventData.meetingType.trim() === "") {
      errors.meetingType = "Meeting type is required";
    }

    if (eventData.meetingType === "Remote") {
      if (!eventData.meetLink || eventData.meetLink.trim() === "") {
        errors.meetLink = "Meeting link is required for online meetings";
      } else if (!eventData.meetLink.startsWith("http://") && !eventData.meetLink.startsWith("https://")) {
        errors.meetLink = "Please enter a valid URL starting with http:// or https://";
      }
    } else if (eventData.meetingType === "Others") {
      if (!eventData.location || eventData.location.trim() === "") {
        errors.location = "Location is required for offline meetings";
      }
    }

    if (!eventData.eventDate) {
      errors.eventDate = "Event date is required";
    }

    if (!eventData.startTime) {
      errors.startTime = "Start time is required";
    }
    if (!eventData.endTime) {
      errors.endTime = "End time is required";
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async () => {
    if (loading) return;

    setTimeError(null);

    if (!validateForm()) {
      openSnackbar("Please fill in all required fields", "error");
      return;
    }

    const now = dayjs();

    if (!eventData.startTime || !eventData.endTime || !eventData.eventDate) {
      setTimeError("Please select date and both start and end times");
      openSnackbar("Please select date and both start and end times", "error");
      return;
    }

    const startDateTime = eventData.eventDate
      .hour(eventData.startTime.hour())
      .minute(eventData.startTime.minute())
      .second(0);

    const endDateTime = eventData.eventDate
      .hour(eventData.endTime.hour())
      .minute(eventData.endTime.minute())
      .second(0);

    let finalEndDateTime = endDateTime;
    if (endDateTime.isBefore(startDateTime)) {
      finalEndDateTime = endDateTime.add(1, "day");
    }

    if (startDateTime.isBefore(now)) {
      const errorMsg = "Cannot schedule events in the past";
      setTimeError(errorMsg);
      openSnackbar(errorMsg, "error");
      return;
    }

    if (finalEndDateTime.isBefore(startDateTime)) {
      const errorMsg = "End time must be after start time";
      setTimeError(errorMsg);
      openSnackbar(errorMsg, "error");
      return;
    }

    const formattedData = {
      ...eventData,
      startTime: startDateTime.toISOString(),
      endTime: finalEndDateTime.toISOString(),
      attendees: eventData.attendees.map((attendee) => ({
        name: attendee.name,
        user_ref_id: attendee.user_ref_id,
        email: attendee.email,
        profile_pic: attendee.profile_pic,
      })),
    };
    delete formattedData.eventDate;

    const excludeId = eventData.id || null;
    const conflictingEvent = companyCalender.find((event) => {
      if (excludeId && event.id === excludeId) return false;
      const existingStart = dayjs(event.startTime);
      const existingEnd = dayjs(event.endTime);
      return startDateTime.isBefore(existingEnd) && finalEndDateTime.isAfter(existingStart);
    });

    if (conflictingEvent) {
      setConflictInfo({
        startTime: dayjs(conflictingEvent.startTime).format("HH:mm:ss"),
        endTime: dayjs(conflictingEvent.endTime).format("HH:mm:ss"),
      });
      setPendingFormattedData(formattedData);
      setConflictDialogOpen(true);
      return;
    }

    await saveEvent(formattedData);
  };

  const handleDateChange = (newDate) => {
    if (!newDate) return;
    const now = dayjs();
    if (newDate.isBefore(now, "day")) {
      const errorMsg = "Cannot select a past date";
      setTimeError(errorMsg);
      openSnackbar(errorMsg, "error");
      return;
    }
    setEventData({ ...eventData, eventDate: newDate });
    setTimeError(null);
    if (validationErrors.eventDate) {
      setValidationErrors(prev => ({ ...prev, eventDate: null }));
    }
  };

  const handleStartTimeChange = (newTime) => {
    if (!newTime) return;
    setEventData({
      ...eventData,
      startTime: newTime,
      endTime: newTime.isAfter(eventData.endTime)
        ? newTime.add(1, "hour")
        : eventData.endTime,
    });
    setTimeError(null);
    if (validationErrors.startTime) {
      setValidationErrors(prev => ({ ...prev, startTime: null }));
    }
  };

  const handleEndTimeChange = (newTime) => {
    if (!newTime) return;
    setEventData({ ...eventData, endTime: newTime });
    setTimeError(null);
    if (validationErrors.endTime) {
      setValidationErrors(prev => ({ ...prev, endTime: null }));
    }
  };

  const onChangeLocation = async (input) => {
    try {
      if (!input || typeof input !== "string") {
        setLocations([]);
        return;
      }
      if (input.length > 2) {
        setLocations([]);
        const response = await getGoogleLocalPlaces(input);
        if (Array.isArray(response)) {
          setLocations(response?.map((place) => ({ description: place, placeId: place })));
        } else if (response?.predictions) {
          const validLocations = response.predictions
            .filter((place) => place?.description)
            .map((place) => ({
              description: place.description,
              placeId: place.place_id || place.description,
            }));
          setLocations(validLocations);
        } else {
          setLocations([]);
        }
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
      setLocations([]);
    }
  };

  const getVerifiedCurrentCompany = (companies) => {
    return (
      companies?.filter(
        (exp) =>
          exp.is_verified &&
          exp.is_currently_working
      ) || []
    );
  };

  useEffect(() => {
    dispatch(getConnectedReducer());
    dispatch(getExperienceReducer());
  }, []);

  const dropdownMenuProps = {
    MenuProps: {
      sx: { zIndex: DROPDOWN_Z_INDEX },
      container: document.body,
      anchorOrigin: { vertical: "bottom", horizontal: "left" },
      transformOrigin: { vertical: "top", horizontal: "left" },
    },
  };

  const dropdownPopperProps = {
    componentsProps: {
      popper: {
        sx: { zIndex: DROPDOWN_Z_INDEX },
        style: { zIndex: DROPDOWN_Z_INDEX },
        container: document.body,
        modifiers: [
          { name: "preventOverflow", enabled: true, options: { boundary: "window" } },
        ],
      },
    },
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        right: open ? 0 : "-30vw",
        width: "25vw",
        height: "100%",
        backgroundColor: "#fff",
        boxShadow: "-2px 0 10px rgba(0,0,0,0.15)",
        transition: "right 0.3s ease",
        zIndex: 2200,
        overflowY: "auto",
        scrollbarWidth: "none",
      }}
    >
      <Box sx={{ p: 3, pb: 6 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          <Typography variant="h6">
            {eventData?.id ? "Edit Event" : "Schedule Event"}
          </Typography>
          <IconButton onClick={onClose} disabled={loading}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ display: "grid", gap: 3 }}>
          {/* Company Name - Show dropdown only if user has verified company */}
          {hasVerifiedCompany ? (
            <TextField
              select
              label="Company Name"
              fullWidth
              required
              disabled={loading}
              error={!!validationErrors.companyName}
              helperText={validationErrors.companyName}
              value={eventData?.companyName || ""}
              onChange={handleCompanyChange}
              SelectProps={dropdownMenuProps}
            >
              {getVerifiedCurrentCompany(ProfessionalExperience).map((company) => (
                <MenuItem
                  key={company?.id}
                  value={company?.company_name}
                  sx={{ display: "flex", alignItems: "center", gap: 2 }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {company?.company_logo && (
                      <img
                        src={company?.company_logo}
                        alt={company?.company_name}
                        style={{ width: 24, height: 24, objectFit: "contain" }}
                      />
                    )}
                    <Typography>{company?.company_name}</Typography>
                  </Box>
                </MenuItem>
              ))}
            </TextField>
          ) : (
            /* Show disabled text field with user's name when user has only verified education */
            hasOnlyVerifiedEducation && (
              <TextField
                label="Company Name"
                fullWidth
                required
                disabled
                value={eventData?.companyName || userDetails?.name || userDetails?.companyname || ""}
                error={!!validationErrors.companyName}
                helperText={validationErrors.companyName || "Scheduling as yourself"}
                InputProps={{
                  readOnly: true,
                }}
              />
            )
          )}

          <TextField
            label="Title"
            fullWidth
            required
            disabled={loading}
            error={!!validationErrors.title}
            helperText={validationErrors.title}
            value={eventData?.title}
            onChange={(e) => {
              setEventData({ ...eventData, title: e.target.value });
              if (validationErrors.title) {
                setValidationErrors(prev => ({ ...prev, title: null }));
              }
            }}
          />

          <TextField
            label="Description"
            fullWidth
            multiline
            rows={3}
            required
            disabled={loading}
            error={!!validationErrors.description}
            helperText={validationErrors.description}
            value={eventData?.description}
            onChange={(e) => {
              setEventData({ ...eventData, description: e.target.value });
              if (validationErrors.description) {
                setValidationErrors(prev => ({ ...prev, description: null }));
              }
            }}
          />

          <TextField
            select
            label="Meeting Type"
            fullWidth
            required
            disabled={loading}
            error={!!validationErrors.meetingType}
            helperText={validationErrors.meetingType}
            value={eventData.meetingType}
            onChange={(e) => {
              setEventData({ ...eventData, meetingType: e.target.value });
              if (validationErrors.meetingType) {
                setValidationErrors(prev => ({ ...prev, meetingType: null }));
              }
            }}
            SelectProps={dropdownMenuProps}
          >
            <MenuItem value="Remote">Online</MenuItem>
            <MenuItem value="Others">Offline</MenuItem>
          </TextField>

          {eventData.meetingType === "Remote" ? (
            <TextField
              label="Meeting Link"
              fullWidth
              required
              disabled={loading}
              error={!!validationErrors.meetLink}
              helperText={validationErrors.meetLink}
              value={eventData.meetLink}
              onChange={(e) => {
                setEventData({ ...eventData, meetLink: e.target.value });
                if (validationErrors.meetLink) {
                  setValidationErrors(prev => ({ ...prev, meetLink: null }));
                }
              }}
            />
          ) : (
            <Autocomplete
              freeSolo
              options={locations}
              getOptionLabel={(option) => {
                if (!option) return "";
                return typeof option === "string" ? option : option.description || "";
              }}
              value={eventData?.location || null}
              onChange={(event, newValue) => {
                setEventData({
                  ...eventData,
                  location: typeof newValue === "string" ? newValue : newValue?.description || "",
                });
                if (validationErrors.location) {
                  setValidationErrors(prev => ({ ...prev, location: null }));
                }
              }}
              onInputChange={(event, newValue) => {
                if (event?.type === "change") onChangeLocation(newValue);
              }}
              filterOptions={(options, params) => {
                return options.filter((option) => {
                  const value = typeof option === "string" ? option : option.description;
                  return value.toLowerCase().includes(params.inputValue.toLowerCase());
                });
              }}
              disabled={loading}
              {...dropdownPopperProps}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Location"
                  required
                  variant="outlined"
                  fullWidth
                  disabled={loading}
                  error={!!validationErrors.location}
                  helperText={validationErrors.location}
                  InputProps={{ ...params.InputProps, style: { fontSize: "0.875rem" } }}
                />
              )}
              renderOption={(props, option) => (
                <li {...props}>
                  <Typography variant="body2">
                    {typeof option === "string" ? option : option.description}
                  </Typography>
                </li>
              )}
              noOptionsText="No locations found"
              loading={locations.length === 0}
              loadingText="Searching locations..."
            />
          )}

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box>
              <DatePicker
                label="Event Date"
                value={eventData.eventDate}
                onChange={handleDateChange}
                minDate={dayjs()}
                disabled={loading}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    sx: { mb: 2 },
                    error: !!validationErrors.eventDate,
                    helperText: validationErrors.eventDate,
                    required: true
                  },
                  popper: {
                    sx: { zIndex: DROPDOWN_Z_INDEX },
                    container: document.body,
                    modifiers: [
                      { name: "preventOverflow", enabled: true, options: { boundary: "window" } },
                    ],
                  },
                }}
              />

              <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
                <TimePicker
                  label="Start Time"
                  value={eventData.startTime}
                  onChange={handleStartTimeChange}
                  error={!!validationErrors.startTime || !!timeError}
                  helperText={validationErrors.startTime || timeError}
                  disabled={loading}
                  componentsProps={{
                    popper: { sx: { zIndex: DROPDOWN_Z_INDEX }, container: document.body },
                  }}
                />
                <TimePicker
                  label="End Time"
                  value={eventData.endTime}
                  onChange={handleEndTimeChange}
                  error={!!validationErrors.endTime || !!timeError}
                  helperText={validationErrors.endTime || timeError}
                  disabled={loading}
                  componentsProps={{
                    popper: { sx: { zIndex: DROPDOWN_Z_INDEX }, container: document.body },
                  }}
                />
              </Box>
            </Box>
          </LocalizationProvider>

          <Autocomplete
            multiple
            options={interviwersList}
            getOptionLabel={(option) =>
              `${option?.first_name || ""} ${option?.last_name || ""}${option?.email ? ` (${option?.email})` : ""
              }`
            }
            filterOptions={(options, { inputValue }) => {
              const input = inputValue.toLowerCase();
              return options.filter(
                (option) =>
                  (option.first_name?.toLowerCase() || "").includes(input) ||
                  (option.last_name?.toLowerCase() || "").includes(input) ||
                  (option.email?.toLowerCase() || "").includes(input)
              );
            }}
            value={interviwersList?.filter((interviewer) =>
              eventData?.attendees?.some((attendee) => attendee?.email === interviewer?.email)
            )}
            onChange={(_, newValue) => {
              const attendees = newValue?.map((interviewer) => ({
                name: [interviewer.first_name, interviewer.last_name].filter(Boolean).join(" "),
                email: interviewer?.email,
                user_ref_id: interviewer?.reference_id,
                profile_pic:
                  interviewer?.profile_url ||
                  "https://static-00.iconduck.com/assets.00/avatar-default-icon-2048x2048-h6w375ur.png",
              }));
              setEventData({ ...eventData, attendees });
            }}
            disabled={loading}
            {...dropdownPopperProps}
            renderTags={() => null}
            renderOption={(props, option) => (
              <li {...props}>
                <img
                  src={
                    option.profile_url ||
                    "https://static-00.iconduck.com/assets.00/avatar-default-icon-2048x2048-h6w375ur.png"
                  }
                  alt={`${option.first_name || ""} ${option.last_name || ""}`}
                  style={{ width: 32, height: 32, borderRadius: "50%", marginRight: 8, objectFit: "cover" }}
                />
                <span>
                  {option.first_name || ""} {option.last_name || ""}
                </span>
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Attendees"
                placeholder="Search by name or email"
                disabled={loading}
              />
            )}
          />

          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, maxHeight: 150, overflowY: "auto", p: 1, borderRadius: 1 }}>
            {eventData?.attendees?.map((attendee, index) => (
              <Box
                key={attendee.email}
                sx={{ display: "flex", alignItems: "center", gap: 1, p: 1, bgcolor: "background.paper", borderRadius: 4, boxShadow: 1 }}
              >
                <img
                  src={
                    attendee.profile_pic ||
                    "https://www.shutterstock.com/image-vector/default-avatar-profile-icon-transparent-600nw-2463868853.jpg"
                  }
                  alt={attendee.name}
                  style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover" }}
                />
                <Typography variant="body2">{attendee.name}</Typography>
                <IconButton
                  size="small"
                  onClick={() => {
                    const newAttendees = [...eventData.attendees];
                    newAttendees.splice(index, 1);
                    setEventData({ ...eventData, attendees: newAttendees });
                  }}
                  sx={{ ml: 0.5 }}
                  disabled={loading}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            ))}
          </Box>

          <Button
            variant="contained"
            fullWidth
            onClick={handleSubmit}
            disabled={loading}
            sx={{ mt: 2 }}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              eventData?.id ? "Update Event" : "Schedule Event"
            )}
          </Button>
        </Box>
      </Box>

      <Dialog
        open={conflictDialogOpen}
        onClose={() => setConflictDialogOpen(false)}
        sx={{ zIndex: DROPDOWN_Z_INDEX }}
        PaperProps={{ sx: { borderRadius: 3, p: 1, maxWidth: 380, backgroundColor: "#ffffff" } }}
      >
        <DialogTitle sx={{ fontWeight: 700, fontSize: "1.1rem", pb: 0 }}>
          Time Slot Unavailable
          <IconButton
            onClick={() => setConflictDialogOpen(false)}
            sx={{ position: "absolute", right: 8, top: 8, color: "grey.500" }}
            disabled={loading}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 1 }}>
          <DialogContentText sx={{ color: "text.primary", fontSize: "0.95rem" }}>
            The time slot from <strong>{conflictInfo?.startTime}</strong> to{" "}
            <strong>{conflictInfo?.endTime}</strong> is already booked. Are you sure you
            want to select this time?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
          <Button
            onClick={() => setConflictDialogOpen(false)}
            variant="outlined"
            disabled={loading}
            sx={{ textTransform: "none", fontWeight: 600, borderColor: "#ccc", color: "text.primary", borderRadius: 2, flex: 1 }}
          >
            Change Time
          </Button>
          <Button
            onClick={async () => {
              setConflictDialogOpen(false);
              await saveEvent(pendingFormattedData);
              setPendingFormattedData(null);
            }}
            variant="contained"
            disabled={loading}
            sx={{ textTransform: "none", fontWeight: 600, backgroundColor: "#0044C6", borderRadius: 2, flex: 1, "&:hover": { backgroundColor: "#0035a0" } }}
          >
            Select Anyway
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ScheduleEvent;